import React, { useState } from 'react';
import { styled } from '@mui/system';

import Dialog from '@mui/material/Dialog';

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 
import dayjs from 'dayjs';

const theme = createTheme();




const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));

const CreateProjectDialog = (props) => {
  const [open, setOpen] = React.useState(false);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('sm');
  const [projectName, setProjectName] = useState('');
  const [projectScope, setProjectScope] = useState('');
  const [duedate, setSetduedate] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProjectTitle = (e) => {
    setProjectName(e.target.value);
  };
  const handleProjectScope = (e) => {
    setProjectScope(e.target.value);
  };
  const handleDateChange = (e) => {
    setSetduedate(e.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
      <button
        className='btn btn-secondary deca-btn-yellow a-update-email-alert'
        onClick={handleClickOpen}
        disabled={props.wareHouseId === ''}
      >
        Create Project
      </button>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
      >
        <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.8em' }}>Add New Project</p>
        </CustomDialogTitle>

        <CustomDialogContent dividers>
          <form
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            onSubmit={(event) => {
              event.preventDefault();

              let storeId = props.wareHouseId;

              projectName && projectScope
                ? props.addProject(projectName, projectScope, duedate, storeId)
                : setOpen(false);

              setOpen(false);
            }}
          >
            <div className='form-group'>
              <div className='col-sm-9'>
                <TextField
                  type='text'
                  name='cityLeader'
                  id='standard-basic'
                  label='Enter Project Title:'
                  onChange={handleProjectTitle}
                  style={{ border: 'none', width: '300px' }}
                  required
                />
              </div>
            </div>
            <div className='form-group'>
              <div className='col-sm-9'>
                <TextField
                  multiline
                  type='text'
                  id='CityLeader'
                  onChange={handleProjectScope}
                  label='Enter Scope Of The Project:'
                  style={{
                    border: 'none',
                    padding: '10px',
                    marginBottom: '30px',
                    width: '300px',
                  }}
                  required
                />
              </div>
            </div>
            <div className='form-group'>
              <div className='col-sm-9'>
                <TextField
                  type='date'
                  label='Enter the Due Date:'
                  id='Startdate'
                  //min={moment().format("YYYY-MM-DD")}

                  InputProps={{
                    inputProps: { min: dayjs().format('YYYY-MM-DD') },
                  }}
                  defaultValue={dayjs().format('YYYY-MM-DD')}
                  onChange={handleDateChange}
                  style={{ border: 'none' }}
                  required
                />
              </div>
            </div>

            <div className='form-group date-color'>
              <div className='col-sm-offset-2 col-sm-10'>
                <button
                  style={{ marginLeft: '54%', marginTop: '5%' }}
                  onClick={handleClose}
                  type='button'
                  className='btn muted-button  deca-btn-orange a-btn-cancel'
                >
                  Cancel
                </button>

                <button
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  style={{ marginLeft: '2%', marginTop: '5%' }}
                >
                  Add Project
                </button>
              </div>
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default CreateProjectDialog;
